<template>
  <v-container fluid class="creativeproject-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-project`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-folder</v-icon>
            Project
          </v-tab>
          <v-tab
            :href="`#tab-assign`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-edit</v-icon>
            Assign
          </v-tab>
          <v-tab-item
            :value="'tab-project'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center" style="margin-top: 5px;">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">{{ initvalue.projectname }}</p>
                      </v-col>
                      <v-col md="1" align="right">
                        <v-btn
                        class="button-shadow"
                        color="primary"
                      @click="Done"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="no-gutters" style="margin-left: 5px;">
                <v-col cols="12" md="2">
                  <div style="align-content: top;">
                    <v-img
                        v-if="initvalue.projectimage" 
                        v-bind:src="initvalue.projectimage"
                        max-height="170"
                        max-width="170"
                        contain
                    ></v-img>
                  </div>
                </v-col>
                <v-col cols="12" md="10">
                  <v-row class="no-gutters">
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        
                        <tr>
                          <td><span style="font-weight: 700;">Date</span></td>
                          <td>{{ new Date(initvalue.projectdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Channel</span></td>
                          <td>{{ initvalue.projectchannel }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Type</span></td>
                          <td>{{ initvalue.projecttype }}</td>
                        </tr>
                        <tr v-if="initvalue.projectchannel=='Writing'">
                          <td><span style="font-weight: 700;">Language</span></td>
                          <td>{{ initvalue.languagecode }}</td>
                        </tr>
                        <tr v-if="initvalue.projectchannel=='Design'">
                          <td><span style="font-weight: 700;">Format</span></td>
                          <td>{{ initvalue.projectformat }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Marketing</span></td>
                          <td>{{ initvalue.mktprojectname }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Business</span></td>
                          <td>{{ initvalue.bizprojectid }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td style="vertical-align: text-top;"><span style="font-weight: 700;">Requestor</span></td>
                          <td>
                            <p class="two-line">{{ initvalue.requestorname }}</p>
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: text-top;"><span style="font-weight: 700;">Creator</span></td>
                          <td>
                            <p v-if="initvalue.repid!=null" class="two-line">{{ initvalue.creatorname }}</p>
                          </td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Complete By</span></td>
                          <td>{{ new Date(initvalue.projectreqdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                  <v-row class="no-gutters" style="margin-top: 10px;">
                    <v-col cols="12" md="12">
                      <v-row class="ma-0">
                        <p class="two-line" style="font-weight: 800;"><u>Project Description</u></p>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col>
                          <p class="two-line" v-html="initvalue.projectdesc.replace('\n', '<br>')"></p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div style="margin-bottom: 5px;">&nbsp;</div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-assign'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">Assign Creator&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="data_users.map(x => {return {text: `${x.username} (${x.companycode})`, value: x._id}})"
                        v-model="update_project.repid"
                        outlined
                        dense
                        placeholder="Creator"
                        persistent-hint
                        single-line hint="Please choose the creator">
                      </v-select>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="4">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/creativeproject/team/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="updateCreativeProject()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>


    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {



      initvalue: {},
      creativeproject: {},
      data_users: [],
      mktprojects: [],

      
      error: undefined,
      haserror: false,
      errorindex: undefined,
      imageurl: undefined,
      company1: null,
      company2: null,
      update_project: {},
    }
  },
  computed: {
    ...mapState('CreativeProject', ['isReceiving']),
  },
  methods: {
    ...mapActions('CreativeProject', [ 'getCreativeProjectsRequest','updateCreativeProjectAssignRequest']),
    ...mapActions('User', ['getUsersCreativeProjectRequest']),
    Done() {
      //this.$router.replace({ name: this.initvalue._isFrom });
      this.$router.push({ name: 'CreativeProjectTeamList' });
    },
    async updateCreativeProject() {
      this.update_project._id = this.initvalue._id;
      console.log(this.update_project);
      await this.updateCreativeProjectAssignRequest(this.update_project);
      router.push('/creativeproject/team/list');
    },
 
  },

  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'CreativeProjectTeamList' });
    this.data_users = await this.getUsersCreativeProjectRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
